import React from "react";
import LicenseCard from "../../components/licenses/LicenseCard";
import Layout from "../../components/layout/Layout";

const LicensesPage = () => {
  // Üç adet plan verisi
  const plans = [
    {
      planName: "Standard Plan",
      price: 49,
      features: [
        { name: "2 team members", available: true },
        { name: "20GB Cloud storage", available: true },
        { name: "Integration help", available: true },
        { name: "Sketch Files", available: false },
        { name: "API Access", available: false },
        { name: "Complete documentation", available: false },
        { name: "24x7 phone & email support", available: false },
      ],
      buttonText: "Choose plan",
    },
    {
      planName: "Pro Plan",
      price: 99,
      features: [
        { name: "5 team members", available: true },
        { name: "100GB Cloud storage", available: true },
        { name: "Integration help", available: true },
        { name: "Sketch Files", available: true },
        { name: "API Access", available: true },
        { name: "Complete documentation", available: false },
        { name: "24x7 phone & email support", available: false },
      ],
      buttonText: "Choose plan",
    },
    {
      planName: "Enterprise Plan",
      price: 199,
      features: [
        { name: "Unlimited team members", available: true },
        { name: "1TB Cloud storage", available: true },
        { name: "Integration help", available: true },
        { name: "Sketch Files", available: true },
        { name: "API Access", available: true },
        { name: "Complete documentation", available: true },
        { name: "24x7 phone & email support", available: true },
      ],
      buttonText: "Contact sales",
    },
  ];

  return (
    <Layout>
      <div className="pt-16 ml-64">
        <main className="flex-1 flex items-center justify-center p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {plans.map((plan, index) => (
              <LicenseCard
                key={index}
                planName={plan.planName}
                price={plan.price}
                features={plan.features}
                buttonText={plan.buttonText}
              />
            ))}
          </div>
        </main>
      </div>
    </Layout>
  );
};

export default LicensesPage;
